export const UNLIMBO_ACTIONS = 'UNLIMBO_ACTIONS';
export const REDUCER_UNLIMBO_ACTIONS = 'REDUCER_UNLIMBO_ACTIONS';

export const unlimboActions = (limboKey: string) => ({
  type: UNLIMBO_ACTIONS,
  data: {
    limboKey
  }
})
